/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Note_PlaceholderInputs */

const en_us2_profile_editors_pain_note_placeholder = /** @type {(inputs: Profile_Editors_Pain_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E.g. a sharp twinge in a deep squat`)
};

const pt_br2_profile_editors_pain_note_placeholder = /** @type {(inputs: Profile_Editors_Pain_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ex.: pontada ao agachar fundo`)
};

const es_419_profile_editors_pain_note_placeholder = /** @type {(inputs: Profile_Editors_Pain_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ej.: una punzada al bajar en sentadilla profunda`)
};

const pt_pt2_profile_editors_pain_note_placeholder = /** @type {(inputs: Profile_Editors_Pain_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ex.: pontada ao agachar fundo`)
};

const fr_fr2_profile_editors_pain_note_placeholder = /** @type {(inputs: Profile_Editors_Pain_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ex. : élancement en squat profond`)
};

const de_de2_profile_editors_pain_note_placeholder = /** @type {(inputs: Profile_Editors_Pain_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z. B. ein Stechen in der tiefen Kniebeuge`)
};

const it_it2_profile_editors_pain_note_placeholder = /** @type {(inputs: Profile_Editors_Pain_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es.: una fitta nello squat profondo`)
};

/**
* | output |
* | --- |
* | "E.g. a sharp twinge in a deep squat" |
*
* @param {Profile_Editors_Pain_Note_PlaceholderInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_note_placeholder = /** @type {((inputs?: Profile_Editors_Pain_Note_PlaceholderInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Note_PlaceholderInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_note_placeholder(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_note_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_note_placeholder(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_note_placeholder(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_note_placeholder(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_note_placeholder(inputs)
	return en_us2_profile_editors_pain_note_placeholder(inputs)
});
export { profile_editors_pain_note_placeholder as "profile-editors.pain_note_placeholder" }